<template>
    <SrMenu v-model="isDatePickerOpen" offset-y min-width="280" :close-on-content-click="false" attach>
        <template #activator="{ on, attrs }">
            <VTextField
                ref="dateTextField"
                v-model="internalDate"
                :class="classList"
                :outlined="outlined"
                readonly
                v-bind="{ ...attrs, ...$attrs }"
                :disabled="disabled"
                v-on="on"
            >
                <template #label>
                    <SrInputLabel :label="label" :required="required" />
                </template>
                <template #append>
                    <div class="d-flex align-center">
                        <div class="mr-2 timezone-offset">UTC{{ timezoneOffset }}</div>
                        <SrIcon class="pointer" icon="calendar" size="s" :disabled="disabled" v-on="disabled ? '' : on" />
                    </div>
                </template>
            </VTextField>
        </template>
        <VDatePicker
            v-model="internalDate"
            color="brand-red"
            :min="minDate"
            :max="maxDate"
            no-title
            :input-attr="{ required: 'true' }"
            @input="closeDatePicker"
        />
    </SrMenu>
</template>

<script>
import { format, utcToZonedTime } from 'date-fns-tz';
import SrIcon from '../SrIcon/SrIcon';
import SrInputLabel from '../SrInputLabel/SrInputLabel';
import SrMenu from '../SrMenu/SrMenu';
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'date-input';

export default {
    name: 'DateInput',
    components: { SrIcon, SrInputLabel, SrMenu },
    model: {
        prop: 'date',
    },
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
        },
        max: {
            type: Date,
            default: undefined,
        },
        min: {
            type: Date,
            default: undefined,
        },
        /**
         * @model
         */
        date: {
            type: String,
            default: null,
        },
        /**
         * Defines whether the inputs style should be outlined or not
         */
        outlined: {
            type: Boolean,
            default: true,
        },
        /**
         * Defines the label for the input
         */
        label: {
            type: String,
            default: 'Date',
        },
        /**
         * Defines the target time zone
         */
        timeZone: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            internalDate: this.date,
            isDatePickerOpen: false,
        };
    },
    computed: {
        minDate() {
            if (this.min) {
                return format(utcToZonedTime(this.min, this.timeZone), 'yyyy-MM-dd').toString();
            }
            return undefined;
        },
        maxDate() {
            if (this.max) {
                return format(utcToZonedTime(this.max, this.timeZone), 'yyyy-MM-dd').toString();
            }
            return undefined;
        },
        timezoneOffset() {
            const dummyDate = new Date().valueOf();
            const timezoneOffset = format(dummyDate, 'XXX', { timeZone: this.timeZone });
            if (timezoneOffset === 'UTCZ') {
                return '+00:00';
            }

            return timezoneOffset;
        },
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
    watch: {
        date: 'setDateFromModel',
        internalDate: 'emitDateChange',
    },
    methods: {
        setDateFromModel() {
            this.internalDate = this.date;
        },
        emitDateChange() {
            this.$emit('input', this.internalDate);
        },
        closeDatePicker() {
            this.isDatePickerOpen = false;
        },
    },
};
</script>
